module.exports = __webpack_public_path__ + "static/media/preg.e39d74a0.jpg";